export function Spinner({ size = 32 }: { size?: number }) {
  return (
    <div
      className="border-2 border-line border-t-accent rounded-full animate-spin"
      style={{ width: size, height: size }}
      aria-label="Caricamento in corso"
    />
  );
}
